<template>
  <div
    class="scrollable-container"
    :style="`width: ${width}px; height: ${height};`"
    @mousewheel.prevent="onMouseWheel"
  >
    <div :id="id" class="inner" :style="`width: ${width}; transform: translateY(${y}px)`">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScrollableContainer",
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      id: Date.now(),
      innerHeight: 0,
      dy: 0,
      y: 0
    };
  },
  watch: {
    y: function(val) {
      this.$emit("change", val);
    }
  },
  mounted() {},
  methods: {
    auto() {
      const innerElement = document.getElementById(this.id);
      this.innerHeight = innerElement.offsetHeight;
    },
    onMouseWheel(e) {
      this.auto();

      this.dy += e.wheelDeltaY;

      // 滚轮向下
      if (this.dy < -100) {
        const scrollHeight = this.innerHeight;
        const maxHeight = this.height;
        this.y -= 100;
        if (this.y + scrollHeight < maxHeight) {
          this.y = maxHeight - scrollHeight;
        }
        if (this.innerHeight < this.height) {
          this.y = 0;
        }
        this.dy = 0;
      }
      // 滚轮向上
      if (this.dy > 100) {
        this.y += 100;
        if (this.y > 0) {
          this.y = 0;
        }
        this.dy = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.scrollable-container {
  overflow: hidden;
}
</style>